// extracted by mini-css-extract-plugin
export default {"root":"StatusLabel_root__a-wV7","pending":"StatusLabel_pending__t51bI","failed":"StatusLabel_failed__Ok5WB"};